import { createContext } from "react";

const JourneyContext=createContext(null);

export default JourneyContext;